import { render, staticRenderFns } from "./fileadministrationTop.vue?vue&type=template&id=22b490cb&scoped=true&"
import script from "./fileadministrationTop.vue?vue&type=script&lang=js&"
export * from "./fileadministrationTop.vue?vue&type=script&lang=js&"
import style0 from "./fileadministrationTop.vue?vue&type=style&index=0&id=22b490cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b490cb",
  null
  
)

export default component.exports